"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredPrivateChatsContext = void 0;
const react_1 = require("react");
exports.FilteredPrivateChatsContext = (0, react_1.createContext)({});
